export const MIXPANEL_EVENTS = {
	APP_WEB_VITAL_SCORE        : 'App Web Vital Score',
	APP_OPENED                 : 'App Opened',
	STICKY_HEADER_RENDER       : 'Sticky Header Render',
	THEME_CHANGED              : 'Theme Changed',
	LOGO_CLICKED               : 'Logo Clicked',
	HAMBURGER_ICON_CLICKED     : 'Hamburger Icon Clicked',
	SIDEBAR_CLOSE_ICON_CLICKED : 'Sidebar Close Icon Clicked',
	NAVIGATION_CLICKED         : 'Navigation Clicked',
	SOURCE_CODE_LINK_CLICKED   : 'Source Code Link Clicked',
	COPY_CODE_BUTTON_CLICKED   : 'Copy Code Button Clicked',
	CODE_HIGHLIGHTED_SUCCESS   : 'Code Highlighted Success',
	CODE_HIGHLIGHTED_ERROR     : 'Code Highlighted Error',
	APP_ERROR                  : 'App Error',
} as const;

export const MIXPANEL_EVENT_PROPERTIES = {
	APP_LOAD_TIME        : 'App Load Time',
	CURRENT_PAGE         : 'Current Page',
	THEME                : 'Theme',
	LOGO_DISPLAY_CONTEXT : 'Logo Display Context',
	IS_MOBILE            : 'Is Mobile',
	IS_MOBILE_VIEW_PORT  : 'Is Mobile View Port',
	NAVIGATION_CONTEXT   : 'Navigation Context',
	NAVIGATION_TITLE     : 'Navigation Title',
	CODE_INITIALS        : 'Code Initials',
	ERROR_MESSAGE        : 'Error Message',
	EVENT_LABEL          : 'Event Label',
	EVENT_NAME           : 'Event Name',
	EVENT_VALUE          : 'Event Value',
	EVENT_ID             : 'Event Id',
	CONNECTION_MODE      : 'Connection Mode',
	CONNECTION_SPEED     : 'Connection Speed',
	RATING               : 'Rating',
	NAVIGATION_TYPE      : 'Navigation Type',
	REFERRER             : 'Referrer',
	ERROR_STACK          : 'Error Stack',
	ERROR_TYPE           : 'Error Type',
	ERROR_FILENAME       : 'Error Filename',
	ERROR_LINENO         : 'Error Line Number',
	ERROR_COLNO          : 'Error Column Number',
	COMPONENT_STACK      : 'Component Stack',
	ERROR_REASON         : 'Error Reason',
	ERROR_NAME           : 'Error Name',
	ERROR_DIGEST         : 'Error Digest',
} as const;